module.exports = __webpack_public_path__ + "static/img/cover2.884b1da.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/cover2.jpg
// module id = KbAh
// module chunks = 3